import MyContext from "../../../../contexts/MyContext";
import { TicketForm2New } from "../ticket-forms/TicketForm2New";
export const Slide2New = (props) => {
  return (
    <MyContext.Consumer>
      {(context) => (
        <div hidden={context.activeSlide !== 1}>
          <TicketForm2New {...props} />
        </div>
      )}
    </MyContext.Consumer>
  );
};
